import { apiClient, type PageEntity, type AreaListExEntity } from '@/libs/api'
import { type AreasListRequestQuery } from '@/libs/api/types'

export type FetchAreasListQuery = {
  tenantKey: string
  query: AreasListRequestQuery
}

export type FetchAreasListResponse = {
  data: AreaListExEntity[]
  pagination: PageEntity | null
}

// エリアマスタ一覧画面用 エリア一覧取得api
export const fetchAreasList = async (
  { tenantKey, query }: FetchAreasListQuery,
  signal?: AbortSignal
): Promise<FetchAreasListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .areas.list.$get({
      query,
      config: { signal }
    })
  return { data, pagination }
}
